import { render, staticRenderFns } from "./invite-overlay.vue?vue&type=template&id=7ed96198&scoped=true&"
import script from "./invite-overlay.ts?vue&type=script&lang=ts&"
export * from "./invite-overlay.ts?vue&type=script&lang=ts&"
import style0 from "./invite-overlay.vue?vue&type=style&index=0&id=7ed96198&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed96198",
  null
  
)

export default component.exports